export const COMPANY = {
  name: "TULSI TRADING AND LOGISTICS",
  address: "62 RAJA SC MULLICK ROAD, 1ST FLOOR",
  city: "KOLKATA - 700084",
  state: "West Bengal",
  stateCode: "19",
  email: "tulsitradinglogistics@gmail.com",
  gstin: "19AAZFT4912H1ZI",
  pan: "AAZFT4912H",
  bankName: "",
  accountNumber: "",
  ifsc: "",
  branch: "",
};

export const GST_OPTIONS = [
  { label: "5% (2.5 CGST + 2.5 SGST)", value: 5 },
  { label: "18% (9 CGST + 9 SGST)", value: 18 },
  { label: "Nil / 0%", value: 0 },
];

export function inr(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(Number(n));
}

export function formatDate(s) {
  if (!s) return "—";
  try {
    const d = typeof s === "string" ? new Date(s) : s;
    if (isNaN(d.getTime())) return s;
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return s;
  }
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

/**
 * Escape a value for safe inclusion in a CSV cell.
 * - Prefixes leading `= + - @ \t \r` with a single quote to defuse Excel/Sheets
 *   formula injection (CWE-1236 / OWASP CSV Injection).
 * - Wraps in double quotes and escapes internal quotes.
 * Always use this when writing a CSV row from arbitrary/user-provided text.
 */
export function csvCell(value) {
  if (value === null || value === undefined) return "";
  let s = String(value);
  // Neutralize spreadsheet formula triggers at cell start.
  if (/^[=+\-@\t\r]/.test(s)) s = "'" + s;
  return '"' + s.replace(/"/g, '""') + '"';
}

/** Build a CSV row (array → comma-joined + newline) with formula-injection escaping. */
export function csvRow(cells) {
  return cells.map(csvCell).join(",") + "\n";
}

// Convert number to Indian words (for invoice amount in words)
const ones = ["", "ONE", "TWO", "THREE", "FOUR", "FIVE", "SIX", "SEVEN", "EIGHT", "NINE",
  "TEN", "ELEVEN", "TWELVE", "THIRTEEN", "FOURTEEN", "FIFTEEN", "SIXTEEN", "SEVENTEEN", "EIGHTEEN", "NINETEEN"];
const tens = ["", "", "TWENTY", "THIRTY", "FORTY", "FIFTY", "SIXTY", "SEVENTY", "EIGHTY", "NINETY"];

function twoDigit(n) {
  if (n < 20) return ones[n];
  return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
}
function threeDigit(n) {
  const h = Math.floor(n / 100);
  const r = n % 100;
  let s = "";
  if (h) s += ones[h] + " HUNDRED";
  if (h && r) s += " ";
  if (r) s += twoDigit(r);
  return s;
}

export function amountInWords(num) {
  if (num === 0) return "ZERO RUPEES ONLY";
  const n = Math.floor(num);
  const paise = Math.round((num - n) * 100);
  const crore = Math.floor(n / 10000000);
  const lakh = Math.floor((n % 10000000) / 100000);
  const thousand = Math.floor((n % 100000) / 1000);
  const rest = n % 1000;
  let s = "";
  if (crore) s += threeDigit(crore) + " CRORE ";
  if (lakh) s += threeDigit(lakh) + " LAKH ";
  if (thousand) s += threeDigit(thousand) + " THOUSAND ";
  if (rest) s += threeDigit(rest);
  s = s.trim() + " RUPEES";
  if (paise) s += " AND " + twoDigit(paise) + " PAISE";
  return s + " ONLY";
}
